/* eslint-disable */
import { CheckCircle, XCircle, RefreshCw, ClipboardList } from 'lucide-react';
import { useAnalysisStore } from '../AssetAnalysisStore';
import { useShallow } from 'zustand/react/shallow';

// Icons mapping for summary cards
function getIconByName(name, size = 24) {
	switch (name) {
		case 'Hash':
			return (
				<ClipboardList
					size={size}
					// className='text-[#bfa700]'
					strokeWidth={1.5}
				/>
			);
		case 'CheckCircle':
			return (
				<CheckCircle
					size={size}
					// className='text-[#4caf50]'
					strokeWidth={1.5}
				/>
			);
		case 'XCircle':
			return (
				<XCircle
					size={size}
					// className='text-[#e74c3c]'
					strokeWidth={1.5}
				/>
			);
		case 'RefreshCcw':
			return (
				<RefreshCw
					size={size}
					// className='text-[#f5a623]'
					strokeWidth={1.5}
				/>
			);
		default:
			return (
				// <ClipboardList
				// 	size={size}
				// 	// className='text-[#bfa700]'
				// 	strokeWidth={1.5}
				// />
				<></>
			);
	}
}

const SummaryCards = () => {
	const statsSummary = useAnalysisStore(
		useShallow((state) => state.analysisChartData.statsData)
	);

	return (
		<div className='flex gap-2 my-4'>
			{Object.values(statsSummary)?.map?.(({ label, value, icon }) => (
				<div
					key={label}
					className='flex-1 bg-yellow-50 rounded-lg  border-2 border-slate-200 p-2 flex items-center justify-between shadow-sm'
				>
					<div className='flex items-center gap-1.5'>
						{getIconByName(icon)}
						<div className={`text-gray-500 font-medium ${
							label.length > 20 ? 'text-xs' : 
							label.length > 15 ? 'text-sm' : 
							'text-base'
						}`}>
							{label}
						</div>
					</div>
					<div className='text-lg font-semibold text-gray-800'>
						{value?.toLocaleString()}
					</div>
				</div>
			))}
		</div>
	);
};

export default SummaryCards;
